import { useTranslation } from 'react-i18next';

import { securityGroupsByPermissionService } from '@/api/domains/securityGrouping';
import type { SecurityGroupOption } from '@/api/domains/securityGrouping';
import { useCatalogLoader } from '@/hooks/ui/useCatalogLoader';
import type { CatalogLoaderResult } from '@/hooks/ui/useCatalogLoader';
import { useUI } from '@/hooks/ui/useUI';


export function useSecurityGroupsByPermission(
  skipFetch: boolean = false,
): CatalogLoaderResult<SecurityGroupOption> {
  const { showNotification } = useUI();
  const { t: translate } = useTranslation();

  return useCatalogLoader(
    () => securityGroupsByPermissionService.getByPermission(),
    (group) => ({ value: String(group.id), label: group.name }),
    [],
    skipFetch,
    () => showNotification('error', translate('common:errors.loadingData'), 5000),
  );
}
